import { useQuery } from '@tanstack/react-query'
import { SHOP_QUERY_KEYS } from '@/modules/shop/constants'
import { ShopItemsService } from '@/modules/shop/api/services'
import type { paths } from '@/schema'

type GetShopItemResponse =
	paths['/api/admin/shop/items/{id}']['get']['responses']['200']['content']['application/json']

const useQueryGetShopItem = (id: string) => {
	return useQuery<GetShopItemResponse>({
		queryKey: SHOP_QUERY_KEYS.ITEMS.DETAIL(id),
		queryFn: () => ShopItemsService.getShopItem(id),
		enabled: !!id,
	})
}

export default useQueryGetShopItem
